<template>
  <app-autocomplete
    filter
    :items="options"
    :label="$t('encashmentFileNumber')"
    hide-details
    multiple
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { mapState } from 'vuex';
import { NAMESPACE } from '@/modules/Vouchers/store';

export default {
  name: 'EncashmentFileNumberSelect',

  computed: {
    ...mapState(NAMESPACE, { items: 'encashmentFileNumbers' }),
    options() {
      return [...new Set(this.items.map(({ encashmentFileNumber }) => encashmentFileNumber))];
    }
  }
};
</script>
